module.exports = __webpack_public_path__ + "bfecaf4b7490e93d6c90f0048d1d8da4.MP3";